/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { config } from './configReadonly';
import { createResultSet, createComplexClass, createRangeClass, createEye, createFalse, createNull, createTrue, createBigNumberClass, createMatrixClass, createReplacer, createI, createLN10, createLOG10E, createNaN, createPi, createSQRT1_2 // eslint-disable-line camelcase
, createTau, createEfimovFactor, createFineStructure, createSackurTetrode, createWeakMixingAngle, createFractionClass, createE, createInfinity, createLOG2E, createVersion, createDenseMatrixClass, createPhi, createTyped, createIsInteger, createIsNumeric, createIsPositive, createIsNaN, createEqualScalar, createNumber, createBoolean, createComplex, createSplitUnit, createUnaryPlus, createApply, createCube, createExpm1, createLog10, createMultiplyScalar, createSign, createSquare, createBitNot, createArg, createIm, createNot, createFilter, createForEach, createMap, createErf, createFormat, createIsPrime, createAcos, createAcot, createAcsc, createAsec, createAsin, createAtan, createAtanh, createCosh, createCoth, createCsch, createSech, createSinh, createTanh, createCombinations, createPickRandom, createRandomInt, createLN2, createClone, createHasNumericValue, createTypeOf, createString, createFraction, createUnaryMinus, createAddScalar, createExp, createLog2, createSqrt, createConj, createGetMatrixDataType, createMode, createPrint, createAcosh, createAcsch, createAsinh, createCos, createCsc, createSin, createCombinationsWithRep, createRandom, createSQRT2, createIsNegative, createSparseMatrixClass, createMatrix, createCbrt, createGcd, createMod, createNthRoot, createXgcd, createBitAnd, createBitXor, createOr, createConcat, createDiag, createIdentity, createOnes, createReshape, createSize, createSubset, createZeros, createTo, createRound, createLeftShift, createRightLogShift, createCompare, createCompareText, createSmaller, createLarger, createUnequal, createMax, createImmutableDenseMatrixClass, createFibonacciHeapClass, createSparse, createAcoth, createAtan2, createSec, createAdd, createTrace, createComposition, createIsZero, createAbs, createFloor, createMultiply, createDotMultiply, createRe, createFlatten, createResize, createSqueeze, createProd, createPow, createDotPow, createRightArithShift, createCompareNatural, createEqualText, createLargerEq, createPartitionSelect, createMin, createSpaClass, createAsech, createTan, createSetSize, createNorm, createQuantileSeq, createGamma, createBignumber, createLcm, createBitOr, createKron, createTranspose, createNumeric, createAnd, createSmallerEq, createSort, createCot, createDot, createSum, createFactorial, createPermutations, createCeil, createSubtract, createCross, createCtranspose, createEqual, createIndexClass, createSetCartesian, createSetDistinct, createSetIsSubset, createSetPowerset, createIndex, createFix, createRange, createDivideScalar, createNthRoots, createLsolve, createDeepEqual, createSetDifference, createSetMultiplicity, createHypot, createLup, createSlu, createDet, createDistance, createStirlingS2, createCatalan, createXor, createRow, createDotDivide, createUnitClass, createCreateUnit, createSetSymDifference, createQr, createInv, createExpm, createDivide, createMean, createVariance, createStd, createMultinomial, createAtomicMass, createBohrMagneton, createBoltzmann, createConductanceQuantum, createDeuteronMass, createElectronMass, createFaraday, createFirstRadiation, createGravitationConstant, createHartreeEnergy, createKlitzing, createMagneticConstant, createMolarMass, createMolarPlanckConstant, createNeutronMass, createPlanckCharge, createPlanckLength, createPlanckTemperature, createProtonMass, createReducedPlanckConstant, createSecondRadiation, createStefanBoltzmann, createVacuumImpedance, createColumn, createUsolve, createSetIntersect, createLusolve, createEigs, createIntersect, createBellNumbers, createAvogadro, createClassicalElectronRadius, createElectricConstant, createFermiCoupling, createGravity, createLoschmidt, createMolarMassC12, createNuclearMagneton, createPlanckMass, createQuantumOfCirculation, createSpeedOfLight, createWienDisplacement, createLog, createUnitFunction, createSqrtm, createKldivergence, createBohrRadius, createElementaryCharge, createInverseConductanceQuantum, createMolarVolume, createPlanckTime, createThomsonCrossSection, createLog1p, createMedian, createGasConstant, createPlanckConstant, createSetUnion, createMagneticFluxQuantum, createCoulomb, createMad, createRydberg } from '../factoriesAny';
export var ResultSet = /* #__PURE__ */createResultSet({});
export var Complex = /* #__PURE__ */createComplexClass({});
export var Range = /* #__PURE__ */createRangeClass({});
export var eye = /* #__PURE__ */createEye({});
export var _false = /* #__PURE__ */createFalse({});
export var _null = /* #__PURE__ */createNull({});
export var _true = /* #__PURE__ */createTrue({});
export var BigNumber = /* #__PURE__ */createBigNumberClass({
  config: config
});
export var Matrix = /* #__PURE__ */createMatrixClass({});
export var replacer = /* #__PURE__ */createReplacer({});
export var i = /* #__PURE__ */createI({
  Complex: Complex
});
export var LN10 = /* #__PURE__ */createLN10({
  BigNumber: BigNumber,
  config: config
});
export var LOG10E = /* #__PURE__ */createLOG10E({
  BigNumber: BigNumber,
  config: config
});
export var _NaN = /* #__PURE__ */createNaN({
  BigNumber: BigNumber,
  config: config
});
export var pi = /* #__PURE__ */createPi({
  BigNumber: BigNumber,
  config: config
});
export var SQRT1_2 = /* #__PURE__ */createSQRT1_2({
  BigNumber: BigNumber,
  config: config
});
export var tau = /* #__PURE__ */createTau({
  BigNumber: BigNumber,
  config: config
});
export var efimovFactor = /* #__PURE__ */createEfimovFactor({
  BigNumber: BigNumber,
  config: config
});
export var fineStructure = /* #__PURE__ */createFineStructure({
  BigNumber: BigNumber,
  config: config
});
export var sackurTetrode = /* #__PURE__ */createSackurTetrode({
  BigNumber: BigNumber,
  config: config
});
export var weakMixingAngle = /* #__PURE__ */createWeakMixingAngle({
  BigNumber: BigNumber,
  config: config
});
export var Fraction = /* #__PURE__ */createFractionClass({});
export var e = /* #__PURE__ */createE({
  BigNumber: BigNumber,
  config: config
});
export var _Infinity = /* #__PURE__ */createInfinity({
  BigNumber: BigNumber,
  config: config
});
export var LOG2E = /* #__PURE__ */createLOG2E({
  BigNumber: BigNumber,
  config: config
});
export var version = /* #__PURE__ */createVersion({});
export var DenseMatrix = /* #__PURE__ */createDenseMatrixClass({
  Matrix: Matrix
});
export var phi = /* #__PURE__ */createPhi({
  BigNumber: BigNumber,
  config: config
});
export var typed = /* #__PURE__ */createTyped({
  BigNumber: BigNumber,
  Complex: Complex,
  DenseMatrix: DenseMatrix,
  Fraction: Fraction
});
export var isInteger = /* #__PURE__ */createIsInteger({
  typed: typed
});
export var isNumeric = /* #__PURE__ */createIsNumeric({
  typed: typed
});
export var isPositive = /* #__PURE__ */createIsPositive({
  typed: typed
});
export var isNaN = /* #__PURE__ */createIsNaN({
  typed: typed
});
export var equalScalar = /* #__PURE__ */createEqualScalar({
  config: config,
  typed: typed
});
export var number = /* #__PURE__ */createNumber({
  typed: typed
});

var _boolean = /* #__PURE__ */createBoolean({
  typed: typed
});

export { _boolean as boolean };
export var complex = /* #__PURE__ */createComplex({
  Complex: Complex,
  typed: typed
});
export var splitUnit = /* #__PURE__ */createSplitUnit({
  typed: typed
});
export var unaryPlus = /* #__PURE__ */createUnaryPlus({
  BigNumber: BigNumber,
  config: config,
  typed: typed
});
export var apply = /* #__PURE__ */createApply({
  isInteger: isInteger,
  typed: typed
});
export var cube = /* #__PURE__ */createCube({
  typed: typed
});
export var expm1 = /* #__PURE__ */createExpm1({
  Complex: Complex,
  typed: typed
});
export var log10 = /* #__PURE__ */createLog10({
  Complex: Complex,
  config: config,
  typed: typed
});
export var multiplyScalar = /* #__PURE__ */createMultiplyScalar({
  typed: typed
});
export var sign = /* #__PURE__ */createSign({
  BigNumber: BigNumber,
  Fraction: Fraction,
  complex: complex,
  typed: typed
});
export var square = /* #__PURE__ */createSquare({
  typed: typed
});
export var bitNot = /* #__PURE__ */createBitNot({
  typed: typed
});
export var arg = /* #__PURE__ */createArg({
  typed: typed
});
export var im = /* #__PURE__ */createIm({
  typed: typed
});
export var not = /* #__PURE__ */createNot({
  typed: typed
});
export var filter = /* #__PURE__ */createFilter({
  typed: typed
});
export var forEach = /* #__PURE__ */createForEach({
  typed: typed
});
export var map = /* #__PURE__ */createMap({
  typed: typed
});
export var erf = /* #__PURE__ */createErf({
  typed: typed
});
export var format = /* #__PURE__ */createFormat({
  typed: typed
});
export var isPrime = /* #__PURE__ */createIsPrime({
  typed: typed
});
export var acos = /* #__PURE__ */createAcos({
  Complex: Complex,
  config: config,
  typed: typed
});
export var acot = /* #__PURE__ */createAcot({
  BigNumber: BigNumber,
  typed: typed
});
export var acsc = /* #__PURE__ */createAcsc({
  BigNumber: BigNumber,
  Complex: Complex,
  config: config,
  typed: typed
});
export var asec = /* #__PURE__ */createAsec({
  BigNumber: BigNumber,
  Complex: Complex,
  config: config,
  typed: typed
});
export var asin = /* #__PURE__ */createAsin({
  Complex: Complex,
  config: config,
  typed: typed
});
export var atan = /* #__PURE__ */createAtan({
  typed: typed
});
export var atanh = /* #__PURE__ */createAtanh({
  Complex: Complex,
  config: config,
  typed: typed
});
export var cosh = /* #__PURE__ */createCosh({
  typed: typed
});
export var coth = /* #__PURE__ */createCoth({
  BigNumber: BigNumber,
  typed: typed
});
export var csch = /* #__PURE__ */createCsch({
  BigNumber: BigNumber,
  typed: typed
});
export var sech = /* #__PURE__ */createSech({
  BigNumber: BigNumber,
  typed: typed
});
export var sinh = /* #__PURE__ */createSinh({
  typed: typed
});
export var tanh = /* #__PURE__ */createTanh({
  typed: typed
});
export var combinations = /* #__PURE__ */createCombinations({
  typed: typed
});
export var pickRandom = /* #__PURE__ */createPickRandom({
  config: config,
  typed: typed
});
export var randomInt = /* #__PURE__ */createRandomInt({
  config: config,
  typed: typed
});
export var LN2 = /* #__PURE__ */createLN2({
  BigNumber: BigNumber,
  config: config
});
export var clone = /* #__PURE__ */createClone({
  typed: typed
});
export var hasNumericValue = /* #__PURE__ */createHasNumericValue({
  isNumeric: isNumeric,
  typed: typed
});
export var typeOf = /* #__PURE__ */createTypeOf({
  typed: typed
});
export var string = /* #__PURE__ */createString({
  typed: typed
});
export var fraction = /* #__PURE__ */createFraction({
  Fraction: Fraction,
  typed: typed
});
export var unaryMinus = /* #__PURE__ */createUnaryMinus({
  typed: typed
});
export var addScalar = /* #__PURE__ */createAddScalar({
  typed: typed
});
export var exp = /* #__PURE__ */createExp({
  typed: typed
});
export var log2 = /* #__PURE__ */createLog2({
  Complex: Complex,
  config: config,
  typed: typed
});
export var sqrt = /* #__PURE__ */createSqrt({
  Complex: Complex,
  config: config,
  typed: typed
});
export var conj = /* #__PURE__ */createConj({
  typed: typed
});
export var getMatrixDataType = /* #__PURE__ */createGetMatrixDataType({
  typed: typed
});
export var mode = /* #__PURE__ */createMode({
  isNaN: isNaN,
  isNumeric: isNumeric,
  typed: typed
});
export var print = /* #__PURE__ */createPrint({
  typed: typed
});
export var acosh = /* #__PURE__ */createAcosh({
  Complex: Complex,
  config: config,
  typed: typed
});
export var acsch = /* #__PURE__ */createAcsch({
  BigNumber: BigNumber,
  typed: typed
});
export var asinh = /* #__PURE__ */createAsinh({
  typed: typed
});
export var cos = /* #__PURE__ */createCos({
  typed: typed
});
export var csc = /* #__PURE__ */createCsc({
  BigNumber: BigNumber,
  typed: typed
});
export var sin = /* #__PURE__ */createSin({
  typed: typed
});
export var combinationsWithRep = /* #__PURE__ */createCombinationsWithRep({
  typed: typed
});
export var random = /* #__PURE__ */createRandom({
  config: config,
  typed: typed
});
export var SQRT2 = /* #__PURE__ */createSQRT2({
  BigNumber: BigNumber,
  config: config
});
export var isNegative = /* #__PURE__ */createIsNegative({
  typed: typed
});
export var SparseMatrix = /* #__PURE__ */createSparseMatrixClass({
  Matrix: Matrix,
  equalScalar: equalScalar,
  typed: typed
});
export var matrix = /* #__PURE__ */createMatrix({
  DenseMatrix: DenseMatrix,
  Matrix: Matrix,
  SparseMatrix: SparseMatrix,
  typed: typed
});
export var cbrt = /* #__PURE__ */createCbrt({
  BigNumber: BigNumber,
  Complex: Complex,
  Fraction: Fraction,
  config: config,
  isNegative: isNegative,
  matrix: matrix,
  typed: typed,
  unaryMinus: unaryMinus
});
export var gcd = /* #__PURE__ */createGcd({
  BigNumber: BigNumber,
  DenseMatrix: DenseMatrix,
  equalScalar: equalScalar,
  matrix: matrix,
  typed: typed
});
export var mod = /* #__PURE__ */createMod({
  DenseMatrix: DenseMatrix,
  equalScalar: equalScalar,
  matrix: matrix,
  typed: typed
});
export var nthRoot = /* #__PURE__ */createNthRoot({
  BigNumber: BigNumber,
  equalScalar: equalScalar,
  matrix: matrix,
  typed: typed
});
export var xgcd = /* #__PURE__ */createXgcd({
  BigNumber: BigNumber,
  config: config,
  matrix: matrix,
  typed: typed
});
export var bitAnd = /* #__PURE__ */createBitAnd({
  equalScalar: equalScalar,
  matrix: matrix,
  typed: typed
});
export var bitXor = /* #__PURE__ */createBitXor({
  DenseMatrix: DenseMatrix,
  matrix: matrix,
  typed: typed
});
export var or = /* #__PURE__ */createOr({
  DenseMatrix: DenseMatrix,
  equalScalar: equalScalar,
  matrix: matrix,
  typed: typed
});
export var concat = /* #__PURE__ */createConcat({
  isInteger: isInteger,
  matrix: matrix,
  typed: typed
});
export var diag = /* #__PURE__ */createDiag({
  DenseMatrix: DenseMatrix,
  SparseMatrix: SparseMatrix,
  matrix: matrix,
  typed: typed
});
export var identity = /* #__PURE__ */createIdentity({
  BigNumber: BigNumber,
  DenseMatrix: DenseMatrix,
  SparseMatrix: SparseMatrix,
  config: config,
  matrix: matrix,
  typed: typed
});
export var ones = /* #__PURE__ */createOnes({
  BigNumber: BigNumber,
  config: config,
  matrix: matrix,
  typed: typed
});
export var reshape = /* #__PURE__ */createReshape({
  isInteger: isInteger,
  matrix: matrix,
  typed: typed
});
export var size = /* #__PURE__ */createSize({
  matrix: matrix,
  config: config,
  typed: typed
});
export var subset = /* #__PURE__ */createSubset({
  matrix: matrix,
  typed: typed
});
export var zeros = /* #__PURE__ */createZeros({
  BigNumber: BigNumber,
  config: config,
  matrix: matrix,
  typed: typed
});
export var to = /* #__PURE__ */createTo({
  matrix: matrix,
  typed: typed
});
export var round = /* #__PURE__ */createRound({
  BigNumber: BigNumber,
  DenseMatrix: DenseMatrix,
  equalScalar: equalScalar,
  matrix: matrix,
  typed: typed,
  zeros: zeros
});
export var leftShift = /* #__PURE__ */createLeftShift({
  DenseMatrix: DenseMatrix,
  equalScalar: equalScalar,
  matrix: matrix,
  typed: typed,
  zeros: zeros
});
export var rightLogShift = /* #__PURE__ */createRightLogShift({
  DenseMatrix: DenseMatrix,
  equalScalar: equalScalar,
  matrix: matrix,
  typed: typed,
  zeros: zeros
});
export var compare = /* #__PURE__ */createCompare({
  BigNumber: BigNumber,
  DenseMatrix: DenseMatrix,
  Fraction: Fraction,
  config: config,
  equalScalar: equalScalar,
  matrix: matrix,
  typed: typed
});
export var compareText = /* #__PURE__ */createCompareText({
  matrix: matrix,
  typed: typed
});
export var smaller = /* #__PURE__ */createSmaller({
  DenseMatrix: DenseMatrix,
  config: config,
  matrix: matrix,
  typed: typed
});
export var larger = /* #__PURE__ */createLarger({
  DenseMatrix: DenseMatrix,
  config: config,
  matrix: matrix,
  typed: typed
});
export var unequal = /* #__PURE__ */createUnequal({
  DenseMatrix: DenseMatrix,
  config: config,
  equalScalar: equalScalar,
  matrix: matrix,
  typed: typed
});
export var max = /* #__PURE__ */createMax({
  larger: larger,
  typed: typed
});
export var ImmutableDenseMatrix = /* #__PURE__ */createImmutableDenseMatrixClass({
  DenseMatrix: DenseMatrix,
  smaller: smaller
});
export var FibonacciHeap = /* #__PURE__ */createFibonacciHeapClass({
  larger: larger,
  smaller: smaller
});
export var sparse = /* #__PURE__ */createSparse({
  SparseMatrix: SparseMatrix,
  typed: typed
});
export var acoth = /* #__PURE__ */createAcoth({
  BigNumber: BigNumber,
  Complex: Complex,
  config: config,
  typed: typed
});
export var atan2 = /* #__PURE__ */createAtan2({
  BigNumber: BigNumber,
  DenseMatrix: DenseMatrix,
  equalScalar: equalScalar,
  matrix: matrix,
  typed: typed
});
export var sec = /* #__PURE__ */createSec({
  BigNumber: BigNumber,
  typed: typed
});
export var add = /* #__PURE__ */createAdd({
  DenseMatrix: DenseMatrix,
  SparseMatrix: SparseMatrix,
  addScalar: addScalar,
  equalScalar: equalScalar,
  matrix: matrix,
  typed: typed
});
export var trace = /* #__PURE__ */createTrace({
  add: add,
  matrix: matrix,
  typed: typed
});
export var composition = /* #__PURE__ */createComposition({
  addScalar: addScalar,
  combinations: combinations,
  isInteger: isInteger,
  isNegative: isNegative,
  isPositive: isPositive,
  larger: larger,
  typed: typed
});
export var isZero = /* #__PURE__ */createIsZero({
  typed: typed
});
export var abs = /* #__PURE__ */createAbs({
  typed: typed
});
export var floor = /* #__PURE__ */createFloor({
  config: config,
  round: round,
  typed: typed
});
export var multiply = /* #__PURE__ */createMultiply({
  addScalar: addScalar,
  equalScalar: equalScalar,
  matrix: matrix,
  multiplyScalar: multiplyScalar,
  typed: typed
});
export var dotMultiply = /* #__PURE__ */createDotMultiply({
  equalScalar: equalScalar,
  matrix: matrix,
  multiplyScalar: multiplyScalar,
  typed: typed
});
export var re = /* #__PURE__ */createRe({
  typed: typed
});
export var flatten = /* #__PURE__ */createFlatten({
  matrix: matrix,
  typed: typed
});
export var resize = /* #__PURE__ */createResize({
  config: config,
  matrix: matrix
});
export var squeeze = /* #__PURE__ */createSqueeze({
  matrix: matrix,
  typed: typed
});
export var prod = /* #__PURE__ */createProd({
  multiply: multiply,
  typed: typed
});
export var pow = /* #__PURE__ */createPow({
  Complex: Complex,
  config: config,
  fraction: fraction,
  identity: identity,
  matrix: matrix,
  multiply: multiply,
  number: number,
  typed: typed
});
export var dotPow = /* #__PURE__ */createDotPow({
  DenseMatrix: DenseMatrix,
  equalScalar: equalScalar,
  matrix: matrix,
  pow: pow,
  typed: typed
});
export var rightArithShift = /* #__PURE__ */createRightArithShift({
  DenseMatrix: DenseMatrix,
  equalScalar: equalScalar,
  matrix: matrix,
  typed: typed,
  zeros: zeros
});
export var compareNatural = /* #__PURE__ */createCompareNatural({
  compare: compare,
  typed: typed
});
export var equalText = /* #__PURE__ */createEqualText({
  compareText: compareText,
  isZero: isZero,
  typed: typed
});
export var largerEq = /* #__PURE__ */createLargerEq({
  DenseMatrix: DenseMatrix,
  config: config,
  matrix: matrix,
  typed: typed
});
export var partitionSelect = /* #__PURE__ */createPartitionSelect({
  compare: compare,
  isNaN: isNaN,
  isNumeric: isNumeric,
  typed: typed
});
export var min = /* #__PURE__ */createMin({
  smaller: smaller,
  typed: typed
});
export var Spa = /* #__PURE__ */createSpaClass({
  FibonacciHeap: FibonacciHeap,
  addScalar: addScalar,
  equalScalar: equalScalar
});
export var asech = /* #__PURE__ */createAsech({
  BigNumber: BigNumber,
  Complex: Complex,
  config: config,
  typed: typed
});
export var tan = /* #__PURE__ */createTan({
  typed: typed
});
export var setSize = /* #__PURE__ */createSetSize({
  compareNatural: compareNatural,
  typed: typed
});
export var norm = /* #__PURE__ */createNorm({
  abs: abs,
  add: add,
  conj: conj,
  equalScalar: equalScalar,
  larger: larger,
  matrix: matrix,
  multiply: multiply,
  pow: pow,
  smaller: smaller,
  sqrt: sqrt,
  typed: typed
});
export var quantileSeq = /* #__PURE__ */createQuantileSeq({
  add: add,
  compare: compare,
  multiply: multiply,
  partitionSelect: partitionSelect,
  typed: typed
});
export var gamma = /* #__PURE__ */createGamma({
  BigNumber: BigNumber,
  Complex: Complex,
  config: config,
  multiplyScalar: multiplyScalar,
  pow: pow,
  typed: typed
});
export var bignumber = /* #__PURE__ */createBignumber({
  BigNumber: BigNumber,
  typed: typed
});
export var lcm = /* #__PURE__ */createLcm({
  equalScalar: equalScalar,
  matrix: matrix,
  typed: typed
});
export var bitOr = /* #__PURE__ */createBitOr({
  DenseMatrix: DenseMatrix,
  equalScalar: equalScalar,
  matrix: matrix,
  typed: typed
});
export var kron = /* #__PURE__ */createKron({
  matrix: matrix,
  multiplyScalar: multiplyScalar,
  typed: typed
});
export var transpose = /* #__PURE__ */createTranspose({
  matrix: matrix,
  typed: typed
});
export var numeric = /* #__PURE__ */createNumeric({
  bignumber: bignumber,
  fraction: fraction,
  number: number
});
export var and = /* #__PURE__ */createAnd({
  equalScalar: equalScalar,
  matrix: matrix,
  not: not,
  typed: typed,
  zeros: zeros
});
export var smallerEq = /* #__PURE__ */createSmallerEq({
  DenseMatrix: DenseMatrix,
  config: config,
  matrix: matrix,
  typed: typed
});
export var sort = /* #__PURE__ */createSort({
  compare: compare,
  compareNatural: compareNatural,
  matrix: matrix,
  typed: typed
});
export var cot = /* #__PURE__ */createCot({
  BigNumber: BigNumber,
  typed: typed
});
export var dot = /* #__PURE__ */createDot({
  add: add,
  multiply: multiply,
  typed: typed
});
export var sum = /* #__PURE__ */createSum({
  bignumber: bignumber,
  fraction: fraction,
  add: add,
  config: config,
  typed: typed
});
export var factorial = /* #__PURE__ */createFactorial({
  gamma: gamma,
  typed: typed
});
export var permutations = /* #__PURE__ */createPermutations({
  factorial: factorial,
  typed: typed
});
export var ceil = /* #__PURE__ */createCeil({
  config: config,
  round: round,
  typed: typed
});
export var subtract = /* #__PURE__ */createSubtract({
  DenseMatrix: DenseMatrix,
  addScalar: addScalar,
  equalScalar: equalScalar,
  matrix: matrix,
  typed: typed,
  unaryMinus: unaryMinus
});
export var cross = /* #__PURE__ */createCross({
  matrix: matrix,
  multiply: multiply,
  subtract: subtract,
  typed: typed
});
export var ctranspose = /* #__PURE__ */createCtranspose({
  conj: conj,
  transpose: transpose,
  typed: typed
});
export var equal = /* #__PURE__ */createEqual({
  DenseMatrix: DenseMatrix,
  equalScalar: equalScalar,
  matrix: matrix,
  typed: typed
});
export var Index = /* #__PURE__ */createIndexClass({
  ImmutableDenseMatrix: ImmutableDenseMatrix
});
export var setCartesian = /* #__PURE__ */createSetCartesian({
  DenseMatrix: DenseMatrix,
  Index: Index,
  compareNatural: compareNatural,
  size: size,
  subset: subset,
  typed: typed
});
export var setDistinct = /* #__PURE__ */createSetDistinct({
  DenseMatrix: DenseMatrix,
  Index: Index,
  compareNatural: compareNatural,
  size: size,
  subset: subset,
  typed: typed
});
export var setIsSubset = /* #__PURE__ */createSetIsSubset({
  Index: Index,
  compareNatural: compareNatural,
  size: size,
  subset: subset,
  typed: typed
});
export var setPowerset = /* #__PURE__ */createSetPowerset({
  Index: Index,
  compareNatural: compareNatural,
  size: size,
  subset: subset,
  typed: typed
});
export var index = /* #__PURE__ */createIndex({
  Index: Index,
  typed: typed
});
export var fix = /* #__PURE__ */createFix({
  Complex: Complex,
  ceil: ceil,
  floor: floor,
  typed: typed
});
export var range = /* #__PURE__ */createRange({
  bignumber: bignumber,
  matrix: matrix,
  config: config,
  larger: larger,
  largerEq: largerEq,
  smaller: smaller,
  smallerEq: smallerEq,
  typed: typed
});
export var divideScalar = /* #__PURE__ */createDivideScalar({
  numeric: numeric,
  typed: typed
});
export var nthRoots = /* #__PURE__ */createNthRoots({
  Complex: Complex,
  config: config,
  divideScalar: divideScalar,
  typed: typed
});
export var lsolve = /* #__PURE__ */createLsolve({
  DenseMatrix: DenseMatrix,
  divideScalar: divideScalar,
  equalScalar: equalScalar,
  matrix: matrix,
  multiplyScalar: multiplyScalar,
  subtract: subtract,
  typed: typed
});
export var deepEqual = /* #__PURE__ */createDeepEqual({
  equal: equal,
  typed: typed
});
export var setDifference = /* #__PURE__ */createSetDifference({
  DenseMatrix: DenseMatrix,
  Index: Index,
  compareNatural: compareNatural,
  size: size,
  subset: subset,
  typed: typed
});
export var setMultiplicity = /* #__PURE__ */createSetMultiplicity({
  Index: Index,
  compareNatural: compareNatural,
  size: size,
  subset: subset,
  typed: typed
});
export var hypot = /* #__PURE__ */createHypot({
  abs: abs,
  addScalar: addScalar,
  divideScalar: divideScalar,
  isPositive: isPositive,
  multiplyScalar: multiplyScalar,
  smaller: smaller,
  sqrt: sqrt,
  typed: typed
});
export var lup = /* #__PURE__ */createLup({
  DenseMatrix: DenseMatrix,
  Spa: Spa,
  SparseMatrix: SparseMatrix,
  abs: abs,
  addScalar: addScalar,
  divideScalar: divideScalar,
  equalScalar: equalScalar,
  larger: larger,
  matrix: matrix,
  multiplyScalar: multiplyScalar,
  subtract: subtract,
  typed: typed,
  unaryMinus: unaryMinus
});
export var slu = /* #__PURE__ */createSlu({
  SparseMatrix: SparseMatrix,
  abs: abs,
  add: add,
  divideScalar: divideScalar,
  larger: larger,
  largerEq: largerEq,
  multiply: multiply,
  subtract: subtract,
  transpose: transpose,
  typed: typed
});
export var det = /* #__PURE__ */createDet({
  lup: lup,
  matrix: matrix,
  multiply: multiply,
  subtract: subtract,
  typed: typed,
  unaryMinus: unaryMinus
});
export var distance = /* #__PURE__ */createDistance({
  abs: abs,
  addScalar: addScalar,
  divideScalar: divideScalar,
  multiplyScalar: multiplyScalar,
  sqrt: sqrt,
  subtract: subtract,
  typed: typed,
  unaryMinus: unaryMinus
});
export var stirlingS2 = /* #__PURE__ */createStirlingS2({
  addScalar: addScalar,
  combinations: combinations,
  divideScalar: divideScalar,
  factorial: factorial,
  isInteger: isInteger,
  isNegative: isNegative,
  larger: larger,
  multiplyScalar: multiplyScalar,
  pow: pow,
  subtract: subtract,
  typed: typed
});
export var catalan = /* #__PURE__ */createCatalan({
  addScalar: addScalar,
  combinations: combinations,
  divideScalar: divideScalar,
  isInteger: isInteger,
  isNegative: isNegative,
  multiplyScalar: multiplyScalar,
  typed: typed
});
export var xor = /* #__PURE__ */createXor({
  DenseMatrix: DenseMatrix,
  matrix: matrix,
  typed: typed
});
export var row = /* #__PURE__ */createRow({
  Index: Index,
  matrix: matrix,
  range: range,
  typed: typed
});
export var dotDivide = /* #__PURE__ */createDotDivide({
  DenseMatrix: DenseMatrix,
  divideScalar: divideScalar,
  equalScalar: equalScalar,
  matrix: matrix,
  typed: typed
});
export var Unit = /* #__PURE__ */createUnitClass({
  BigNumber: BigNumber,
  Complex: Complex,
  Fraction: Fraction,
  abs: abs,
  addScalar: addScalar,
  config: config,
  divideScalar: divideScalar,
  equal: equal,
  fix: fix,
  format: format,
  isNumeric: isNumeric,
  multiplyScalar: multiplyScalar,
  number: number,
  pow: pow,
  round: round,
  subtract: subtract
});
export var createUnit = /* #__PURE__ */createCreateUnit({
  Unit: Unit,
  typed: typed
});
export var setSymDifference = /* #__PURE__ */createSetSymDifference({
  Index: Index,
  concat: concat,
  setDifference: setDifference,
  size: size,
  subset: subset,
  typed: typed
});
export var qr = /* #__PURE__ */createQr({
  addScalar: addScalar,
  complex: complex,
  conj: conj,
  divideScalar: divideScalar,
  equal: equal,
  identity: identity,
  isZero: isZero,
  matrix: matrix,
  multiplyScalar: multiplyScalar,
  sign: sign,
  sqrt: sqrt,
  subtract: subtract,
  typed: typed,
  unaryMinus: unaryMinus,
  zeros: zeros
});
export var inv = /* #__PURE__ */createInv({
  abs: abs,
  addScalar: addScalar,
  det: det,
  divideScalar: divideScalar,
  identity: identity,
  matrix: matrix,
  multiply: multiply,
  typed: typed,
  unaryMinus: unaryMinus
});
export var expm = /* #__PURE__ */createExpm({
  abs: abs,
  add: add,
  identity: identity,
  inv: inv,
  multiply: multiply,
  typed: typed
});
export var divide = /* #__PURE__ */createDivide({
  divideScalar: divideScalar,
  equalScalar: equalScalar,
  inv: inv,
  matrix: matrix,
  multiply: multiply,
  typed: typed
});
export var mean = /* #__PURE__ */createMean({
  add: add,
  divide: divide,
  typed: typed
});
export var variance = /* #__PURE__ */createVariance({
  add: add,
  apply: apply,
  divide: divide,
  isNaN: isNaN,
  multiply: multiply,
  subtract: subtract,
  typed: typed
});
export var std = /* #__PURE__ */createStd({
  sqrt: sqrt,
  typed: typed,
  variance: variance
});
export var multinomial = /* #__PURE__ */createMultinomial({
  add: add,
  divide: divide,
  factorial: factorial,
  isInteger: isInteger,
  isPositive: isPositive,
  multiply: multiply,
  typed: typed
});
export var atomicMass = /* #__PURE__ */createAtomicMass({
  BigNumber: BigNumber,
  Unit: Unit,
  config: config
});
export var bohrMagneton = /* #__PURE__ */createBohrMagneton({
  BigNumber: BigNumber,
  Unit: Unit,
  config: config
});
export var boltzmann = /* #__PURE__ */createBoltzmann({
  BigNumber: BigNumber,
  Unit: Unit,
  config: config
});
export var conductanceQuantum = /* #__PURE__ */createConductanceQuantum({
  BigNumber: BigNumber,
  Unit: Unit,
  config: config
});
export var deuteronMass = /* #__PURE__ */createDeuteronMass({
  BigNumber: BigNumber,
  Unit: Unit,
  config: config
});
export var electronMass = /* #__PURE__ */createElectronMass({
  BigNumber: BigNumber,
  Unit: Unit,
  config: config
});
export var faraday = /* #__PURE__ */createFaraday({
  BigNumber: BigNumber,
  Unit: Unit,
  config: config
});
export var firstRadiation = /* #__PURE__ */createFirstRadiation({
  BigNumber: BigNumber,
  Unit: Unit,
  config: config
});
export var gravitationConstant = /* #__PURE__ */createGravitationConstant({
  BigNumber: BigNumber,
  Unit: Unit,
  config: config
});
export var hartreeEnergy = /* #__PURE__ */createHartreeEnergy({
  BigNumber: BigNumber,
  Unit: Unit,
  config: config
});
export var klitzing = /* #__PURE__ */createKlitzing({
  BigNumber: BigNumber,
  Unit: Unit,
  config: config
});
export var magneticConstant = /* #__PURE__ */createMagneticConstant({
  BigNumber: BigNumber,
  Unit: Unit,
  config: config
});
export var molarMass = /* #__PURE__ */createMolarMass({
  BigNumber: BigNumber,
  Unit: Unit,
  config: config
});
export var molarPlanckConstant = /* #__PURE__ */createMolarPlanckConstant({
  BigNumber: BigNumber,
  Unit: Unit,
  config: config
});
export var neutronMass = /* #__PURE__ */createNeutronMass({
  BigNumber: BigNumber,
  Unit: Unit,
  config: config
});
export var planckCharge = /* #__PURE__ */createPlanckCharge({
  BigNumber: BigNumber,
  Unit: Unit,
  config: config
});
export var planckLength = /* #__PURE__ */createPlanckLength({
  BigNumber: BigNumber,
  Unit: Unit,
  config: config
});
export var planckTemperature = /* #__PURE__ */createPlanckTemperature({
  BigNumber: BigNumber,
  Unit: Unit,
  config: config
});
export var protonMass = /* #__PURE__ */createProtonMass({
  BigNumber: BigNumber,
  Unit: Unit,
  config: config
});
export var reducedPlanckConstant = /* #__PURE__ */createReducedPlanckConstant({
  BigNumber: BigNumber,
  Unit: Unit,
  config: config
});
export var secondRadiation = /* #__PURE__ */createSecondRadiation({
  BigNumber: BigNumber,
  Unit: Unit,
  config: config
});
export var stefanBoltzmann = /* #__PURE__ */createStefanBoltzmann({
  BigNumber: BigNumber,
  Unit: Unit,
  config: config
});
export var vacuumImpedance = /* #__PURE__ */createVacuumImpedance({
  BigNumber: BigNumber,
  Unit: Unit,
  config: config
});
export var column = /* #__PURE__ */createColumn({
  Index: Index,
  matrix: matrix,
  range: range,
  typed: typed
});
export var usolve = /* #__PURE__ */createUsolve({
  DenseMatrix: DenseMatrix,
  divideScalar: divideScalar,
  equalScalar: equalScalar,
  matrix: matrix,
  multiplyScalar: multiplyScalar,
  subtract: subtract,
  typed: typed
});
export var setIntersect = /* #__PURE__ */createSetIntersect({
  DenseMatrix: DenseMatrix,
  Index: Index,
  compareNatural: compareNatural,
  size: size,
  subset: subset,
  typed: typed
});
export var lusolve = /* #__PURE__ */createLusolve({
  DenseMatrix: DenseMatrix,
  lsolve: lsolve,
  lup: lup,
  matrix: matrix,
  slu: slu,
  typed: typed,
  usolve: usolve
});
export var eigs = /* #__PURE__ */createEigs({
  abs: abs,
  add: add,
  addScalar: addScalar,
  atan: atan,
  bignumber: bignumber,
  config: config,
  cos: cos,
  equal: equal,
  inv: inv,
  matrix: matrix,
  multiply: multiply,
  multiplyScalar: multiplyScalar,
  sin: sin,
  subtract: subtract,
  typed: typed
});
export var intersect = /* #__PURE__ */createIntersect({
  abs: abs,
  add: add,
  addScalar: addScalar,
  config: config,
  divideScalar: divideScalar,
  equalScalar: equalScalar,
  matrix: matrix,
  multiply: multiply,
  multiplyScalar: multiplyScalar,
  smaller: smaller,
  subtract: subtract,
  typed: typed
});
export var bellNumbers = /* #__PURE__ */createBellNumbers({
  addScalar: addScalar,
  isInteger: isInteger,
  isNegative: isNegative,
  stirlingS2: stirlingS2,
  typed: typed
});
export var avogadro = /* #__PURE__ */createAvogadro({
  BigNumber: BigNumber,
  Unit: Unit,
  config: config
});
export var classicalElectronRadius = /* #__PURE__ */createClassicalElectronRadius({
  BigNumber: BigNumber,
  Unit: Unit,
  config: config
});
export var electricConstant = /* #__PURE__ */createElectricConstant({
  BigNumber: BigNumber,
  Unit: Unit,
  config: config
});
export var fermiCoupling = /* #__PURE__ */createFermiCoupling({
  BigNumber: BigNumber,
  Unit: Unit,
  config: config
});
export var gravity = /* #__PURE__ */createGravity({
  BigNumber: BigNumber,
  Unit: Unit,
  config: config
});
export var loschmidt = /* #__PURE__ */createLoschmidt({
  BigNumber: BigNumber,
  Unit: Unit,
  config: config
});
export var molarMassC12 = /* #__PURE__ */createMolarMassC12({
  BigNumber: BigNumber,
  Unit: Unit,
  config: config
});
export var nuclearMagneton = /* #__PURE__ */createNuclearMagneton({
  BigNumber: BigNumber,
  Unit: Unit,
  config: config
});
export var planckMass = /* #__PURE__ */createPlanckMass({
  BigNumber: BigNumber,
  Unit: Unit,
  config: config
});
export var quantumOfCirculation = /* #__PURE__ */createQuantumOfCirculation({
  BigNumber: BigNumber,
  Unit: Unit,
  config: config
});
export var speedOfLight = /* #__PURE__ */createSpeedOfLight({
  BigNumber: BigNumber,
  Unit: Unit,
  config: config
});
export var wienDisplacement = /* #__PURE__ */createWienDisplacement({
  BigNumber: BigNumber,
  Unit: Unit,
  config: config
});
export var log = /* #__PURE__ */createLog({
  Complex: Complex,
  config: config,
  divideScalar: divideScalar,
  typed: typed
});
export var unit = /* #__PURE__ */createUnitFunction({
  Unit: Unit,
  typed: typed
});
export var sqrtm = /* #__PURE__ */createSqrtm({
  abs: abs,
  add: add,
  identity: identity,
  inv: inv,
  max: max,
  multiply: multiply,
  size: size,
  sqrt: sqrt,
  subtract: subtract,
  typed: typed
});
export var kldivergence = /* #__PURE__ */createKldivergence({
  divide: divide,
  dotDivide: dotDivide,
  isNumeric: isNumeric,
  log: log,
  matrix: matrix,
  multiply: multiply,
  sum: sum,
  typed: typed
});
export var bohrRadius = /* #__PURE__ */createBohrRadius({
  BigNumber: BigNumber,
  Unit: Unit,
  config: config
});
export var elementaryCharge = /* #__PURE__ */createElementaryCharge({
  BigNumber: BigNumber,
  Unit: Unit,
  config: config
});
export var inverseConductanceQuantum = /* #__PURE__ */createInverseConductanceQuantum({
  BigNumber: BigNumber,
  Unit: Unit,
  config: config
});
export var molarVolume = /* #__PURE__ */createMolarVolume({
  BigNumber: BigNumber,
  Unit: Unit,
  config: config
});
export var planckTime = /* #__PURE__ */createPlanckTime({
  BigNumber: BigNumber,
  Unit: Unit,
  config: config
});
export var thomsonCrossSection = /* #__PURE__ */createThomsonCrossSection({
  BigNumber: BigNumber,
  Unit: Unit,
  config: config
});
export var log1p = /* #__PURE__ */createLog1p({
  Complex: Complex,
  config: config,
  divideScalar: divideScalar,
  log: log,
  typed: typed
});
export var median = /* #__PURE__ */createMedian({
  add: add,
  compare: compare,
  divide: divide,
  partitionSelect: partitionSelect,
  typed: typed
});
export var gasConstant = /* #__PURE__ */createGasConstant({
  BigNumber: BigNumber,
  Unit: Unit,
  config: config
});
export var planckConstant = /* #__PURE__ */createPlanckConstant({
  BigNumber: BigNumber,
  Unit: Unit,
  config: config
});
export var setUnion = /* #__PURE__ */createSetUnion({
  Index: Index,
  concat: concat,
  setIntersect: setIntersect,
  setSymDifference: setSymDifference,
  size: size,
  subset: subset,
  typed: typed
});
export var magneticFluxQuantum = /* #__PURE__ */createMagneticFluxQuantum({
  BigNumber: BigNumber,
  Unit: Unit,
  config: config
});
export var coulomb = /* #__PURE__ */createCoulomb({
  BigNumber: BigNumber,
  Unit: Unit,
  config: config
});
export var mad = /* #__PURE__ */createMad({
  abs: abs,
  map: map,
  median: median,
  subtract: subtract,
  typed: typed
});
export var rydberg = /* #__PURE__ */createRydberg({
  BigNumber: BigNumber,
  Unit: Unit,
  config: config
});


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/pureFunctionsAny.generated.js
// module id = 326
// module chunks = 0